// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as DateTime$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as FetchLoadableViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/FetchLoadableViewMapper.bs.js";

function getBrandingInfoDiplayRecord(brandingInfo) {
  return {
          hd: {
            label: "Branding Type",
            value: {
              TAG: /* Text */0,
              _0: brandingInfo.brandingType
            }
          },
          tl: {
            hd: {
              label: "Branding Date",
              value: {
                TAG: /* Text */0,
                _0: DateTime$Catalyst.toString("DD-MM-YYYY", brandingInfo.initialBrandingDate)
              }
            },
            tl: {
              hd: {
                label: "Is Branding Approved",
                value: {
                  TAG: /* Text */0,
                  _0: Pervasives.string_of_bool(brandingInfo.isApproved)
                }
              },
              tl: /* [] */0
            }
          }
        };
}

function getView(driverInfo) {
  return React.createElement(CardComponent$Catalyst.make, {
              children: React.createElement(FetchLoadableViewMapper$Catalyst.make, {
                    loadableData: driverInfo,
                    children: (function (driverInfo) {
                        var brandingInfo = driverInfo.brandingInfo;
                        if (brandingInfo === undefined) {
                          return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                      error: ErrorUtils$Catalyst.getDefaultErrorEntity("Partner has not been branded", undefined, undefined)
                                    });
                        }
                        var match = brandingInfo.blacklistInfo;
                        if (match !== undefined) {
                          return React.createElement(ErrorDisplayComponent$Catalyst.make, {
                                      error: ErrorUtils$Catalyst.getDefaultErrorEntity("Partner's branding is blacklisted", undefined, undefined)
                                    });
                        } else {
                          return React.createElement("div", undefined, CardRowViewMapper$Catalyst.CardRecordView.make("record", getBrandingInfoDiplayRecord(brandingInfo)));
                        }
                      })
                  })
            });
}

export {
  getBrandingInfoDiplayRecord ,
  getView ,
  
}
/* react Not a pure module */
